
import { defineComponent, ref, computed, h, PropType } from "vue";
import { MdPerson } from "@vicons/ionicons4";
import { useMessage, SelectOption, NTag } from "naive-ui";
import HosterInvitePerson from "@/components/hoster/editor/hosterInvitePerson.vue";
import { useStore } from "vuex";
import { Module, Actions, Getters } from "@/store/enums/hosterEnums";
import {
  Module as hosterModule,
  Actions as hosterActions,
} from "@/store/enums/hosterEnums";
import inviteMemberModel from "@/core/models/hoster/inviteMember.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import searchPersonCRUDModel from "@/core/models/hoster/seachPersonCRUD.interface";
import eventModel from "@/core/models/share/inviteEvent.interface";
import { Module as ExposedModule,Actions as ExposedActions, Mutations as ExposedMutations, Getters as ExposedGetters } from "@/store/enums/exposedEnums";

import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
  Permision as ParamPermision,
} from "@/store/enums/paramsEnums";
const createData = () => [
  "Marks",
  "Catherine",
  "Ashely",
  "Patty",
  "Ken",
  "Timo",
  "YuChein",
  "Dain",
];

export default defineComponent({
  props: {
    event: { type: Object as PropType<eventModel | null> },
  },
  components: {
    MdPerson,
    HosterInvitePerson,
  },
  setup(props:any, context:any) {
   
    const valueRef = ref("");
    const checkBoxValueRef = ref(null);
    const store = useStore();
    const message = useMessage();
    const person = computed(
      () => store.getters[ExposedModule.desc + ExposedGetters.MyParticipationEventsResponses]
    );
    

    
    return {
      ParamPermision,
      person,
      valueRef,
      
    };
  },
});
